import _hasIn from 'lodash/hasIn';
import _isNull from 'lodash/isNull';
import _omitBy from 'lodash/omitBy';
import _pick from 'lodash/pick';
import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToSnakeCase, transformClientResponse } from 'helpers/core';
import URLS from 'constants/urls';

const serviceAllowedAttributes = ['name', 'description', 'duration', 'practitionerIds', 'resourceIds'];

export const transformData = rawData => {
  // eslint-disable-next-line no-underscore-dangle
  const data = _omitBy(_pick(rawData, serviceAllowedAttributes), _isNull);

  if (data.duration) {
    data.duration = Number(data.duration);
  }

  return transformKeysToSnakeCase(data);
};

const get = (httpClient, venueId) => {
  const endpoint = URLS.manageServices.services.create(venueId);
  return httpClient
    .get(endpoint)
    .then(transformClientResponse)
    .then(data =>
      data.map(({ duration, ...restService }) => ({
        ...restService,
        duration: Number(duration).toString(),
      }))
    );
};

const put = (httpClient, venueId, data) => {
  const { id, ...restData } = data;
  const endpoint = URLS.manageServices.services.update(venueId, id);
  return httpClient.put(endpoint, transformData(restData));
};

const post = (httpClient, venueId, data) => {
  const endpoint = URLS.manageServices.services.create(venueId);
  return httpClient.post(endpoint, transformData(data));
};

export const handler = ({ httpClient }, venueId, serviceData) => {
  let promise = Promise.resolve();

  if (serviceData) {
    if (_hasIn(serviceData, 'id')) {
      promise = put(httpClient, venueId, serviceData);
    } else {
      promise = post(httpClient, venueId, serviceData);
    }
  }

  return promise.then(() => get(httpClient, venueId));
};

export default makeEntityScaffold('SAGA.API.FETCH_SERVICES', handler, { defaultKey: 1 });
